import React from "react";
import styled from "styled-components";

import { Link } from "@material-ui/core";

const TermsofUseLink = styled(Link)`
    &&& {
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 145%;
        letter-spacing: -0.28px;
        text-decoration-line: underline;
        color: #11a9e2;
    }
`;

export function TermsOfUseAndRefundPolicy() {
    return (
        <span>
            <TermsofUseLink target="_blank" href="https://www.beautiful.ai/terms-of-service">
                Terms of Service
            </TermsofUseLink>
            &nbsp;and&nbsp;
            <TermsofUseLink target="_blank" href="https://support.beautiful.ai/hc/en-us/articles/360030719012-What-is-your-refund-policy">
                Refund Policy
            </TermsofUseLink>
            .
        </span>
    );
}
